import { usePermissionContext } from './permissionProvider';

const usePermission = () => usePermissionContext();

export default usePermission;
